import React, { useState } from 'react'
import EssLeaveRequestForm from './EssLeaveRequestForm'
import essLeaveRequestServices from '../essLeaveRequestServices'
import moment from 'moment'
import { useEssAppData } from '../../../../context/AppESSDataContext'

function ESSLeaveRequest() {

    const {getMasterLabel,employeeDD,getDDDataById} = useEssAppData();
    const [leaveRequestList,setLeaveRequestList] = useState(null)

    const getLeaveRequestList = () =>{
        essLeaveRequestServices.getList().then(res=>{
            setLeaveRequestList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }



    return (
        <>
            
            <div className='row mt-4'>
                <div className='col-md-12'>
                    
                    <span className='float-end'><EssLeaveRequestForm callBack={getLeaveRequestList} /></span>
                    <button className='btn btn-outline-primary float-end me-2' onClick={getLeaveRequestList} >Show Leave Request</button>
                </div>
                {leaveRequestList &&
                <div className='col-md-12'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>From</th>
                                <th>To</th>
                                <th>Day Count</th>
                                <th>Leave Type</th>
                                <th>Message</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leaveRequestList?.map(leaveRequest=>
                                <tr key={leaveRequest.id}>
                                    <td>{moment(leaveRequest.startDate).format("LL")}</td>
                                    <td>{moment(leaveRequest.endDate).format("LL")}</td>
                                    <td>{ moment(leaveRequest.endDate).diff(moment(leaveRequest.startDate),"days")+1 }</td>
                                    <td>{getMasterLabel("leave-type",leaveRequest.leaveType)}</td>
                                    <td>{leaveRequest.message}</td>
                                    <td>
                                        {leaveRequest.status == 1 && <button className='btn btn-warning' >Requested</button>}
                                        {leaveRequest.status == 2 && <button className='btn btn-success' >Approved</button>}
                                        {leaveRequest.status == 3 && <button className='btn btn-danger' >Rejected</button>}

                                        {leaveRequest.updatedBy != null && 
                                            <div>
                                                <span className='fw-bold'>Updated By :</span> {getDDDataById(employeeDD,leaveRequest.updatedBy).label}
                                            </div>
                                        }
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                }
            </div>
        </>
    )
}

export default ESSLeaveRequest